import { makePostRequest } from 'owa-ows-gateway';

type IdType = 'ewsId' | 'restId' | 'restImmutableEntryId';

export interface TranslateExchangeIdsResponseItem {
    SourceId: string;
    TargetId: string;
    ErrorDetails?: {
        Message: string;
        Code: 'NotFound' | string;
    };
}

export default async function translateExchangeIds(
    SourceIdType: IdType,
    TargetIdType: IdType,
    InputIds: string[],
    headers: any
): Promise<TranslateExchangeIdsResponseItem[]> {
    const requestUrl = '/api/beta/me/translateExchangeIds';
    const requestObject = {
        InputIds,
        SourceIdType,
        TargetIdType,
    };

    const correlationId = undefined;
    const returnFullResponse = false;
    const customHeaders = headers;
    const throwServiceError = true;
    const sendPayloadAsBody = true;
    const includeCredentials = undefined;
    const actionName = 'translateExchangeIds';
    const datapoint = {
        customData: {
            sourceIdType_1: SourceIdType,
            targetIdType_2: TargetIdType,
            idCount_3: InputIds.length,
        },
    };

    const response = await (makePostRequest(
        requestUrl,
        requestObject,
        correlationId,
        returnFullResponse,
        customHeaders,
        throwServiceError,
        sendPayloadAsBody,
        includeCredentials,
        actionName,
        datapoint
    ) as Promise<{
        value: TranslateExchangeIdsResponseItem[];
    }>);

    return response.value;
}
